import styled from 'styled-components';

/**
 * A wrapper for `Dialog` action content.
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogActions = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogActions",
  componentId: "c11n-8-111-1__sc-12x2o37-0"
})([""]);
DialogActions.displayName = 'DialogActions';

/** @component */
export { DialogActions };